
import {
  ref,
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
} from "vue";
import { getArticleByCategoryId } from "../views/api/user";
import router from "@/router";
export default defineComponent({
  setup() {
    //获取全局变量

    const proxy = getCurrentInstance() as any;

    let show = ref<any>(true);
    //全局语言
    if (window.sessionStorage.getItem("language") as string) {
      var lan = JSON.parse(proxy.appContext.config.globalProperties.$language);
    }
    if (lan == "EN") {
      show.value = false;
    } else {
      show.value = true;
    }

    const goLink = (id) => {
      if (id == 1) {
        router.push({
          path: "/",
        });
      } else if (id == 2) {
         router.push({
        path: "/aboutUs" 
       });
      } else if (id == 3) {
         router.push({
        path: "/researchInnovation" 
       });
      } else if (id == 4) {
         router.push({
        path: "/technologicalFrontier" 
       });
      } else if (id == 5) {
         router.push({
        path: "/internationalCooperation" 
       });
      } else if (id == 6) {
         router.push({
        path: "/news" 
       });
      } else {
         router.push({
        path: "/committeeExperts" 
       });
      }

      //     if(lan=="EN"){
      //        let name = reactive<any>("News");
      //          router.push({
      //       path: "/article/" + id + "/" + name + "/" + title + "/" + type,
      //     });
      //     }
      //     else{
      //         let name = reactive<any>("新闻");
      // router.push({
      //       path: "/article/" + id + "/" + name + "/" + title + "/" + type,
      //     });
      //     }
    };

    // onMounted(() => {
    // });

    return {
      goLink,
      show,
    };
  },
});
